<template>
  <live-info-options
    v-if="currentDisplay === 'options'"
    :handleSelectOption="handleSelectOption"
    :isStreamingRightNow="isStreamingRightNow"
  />
  <live-status
    v-else-if="currentDisplay === 'liveStatus'"
    :isStreamingRightNow="isStreamingRightNow"
    :customVideoId="customVideoId"
    :streamDetails="streamDetails"
    :liveInfo="liveInfo"
    :liveStatus="liveStatus"
    :serverStatus="serverStatus"
    :timeLeft="timeLeft"
    :errors="errors"
    :lastVerificationServer="lastVerificationServer"
    :handleBackOptions="handleBackOptions"
  />
  <video-traffic
    :handleBack="handleBackOptions"
    v-else-if="currentDisplay === 'traffic'"
    :customVideoId="customVideoId"
  />
  <video-retention
    :handleBack="handleBackOptions"
    v-else-if="currentDisplay === 'retention'"
    :customVideoId="customVideoId"
    :videoPlayer="videoPlayer"
    :videoHls="videoHls"
  />
  <video-views
    :handleBack="handleBackOptions"
    v-else-if="currentDisplay === 'views'"
    :customVideoId="customVideoId"
  />
</template>

<script>
import LiveStatus from './LiveStatus.vue'
import LiveInfoOptions from './LiveInfoOptions.vue'
import VideoTraffic from './VideoTraffic.vue'
import VideoRetention from '../metrics/VideoRetention.vue'
import VideoViews from '../metrics/VideoViews.vue'

export default {
  data: () => ({
    currentDisplay: 'options',
  }),
  components: {
    VideoRetention,
    VideoViews,
    VideoTraffic,
    LiveStatus,
    LiveInfoOptions,
  },
  props: [
    'isStreamingRightNow',
    'liveStatus',
    'serverStatus',
    'timeLeft',
    'errors',
    'liveInfo',
    'lastVerificationServer',
    'isLive',
    'streamDetails',
    'customVideoId',
    'videoPlayer',
    'videoHls',
  ],
  methods: {
    handleSelectOption(option) {
      this.currentDisplay = option
    },
    handleBackOptions() {
      this.handleSelectOption('options')
    },
  },
}
</script>

<style></style>
